import { render, staticRenderFns } from "./OrderListRepair.vue?vue&type=template&id=2319ba74&"
import script from "./OrderListRepair.vue?vue&type=script&lang=js&"
export * from "./OrderListRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports